"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    '(iPhone|iPad|CPU).*OS ([56789]|10)[._].*(Safari|like Mac OS)',
    'BingPreview',
    'Chrome[ /]([123]\\d|4[^1])\\.',
    'CriOS[ /][1234]\\d\\.',
    'DuckDuckGo',
    'Firefox/[1234]\\d?\\.',
    'FxiOS/\\d\\.',
    'GSA',
    'Instagram',
    'MAGIX BROWSER',
    'MIUI',
    'MQQBrowser',
    'MSIE',
    'Media Center PC',
    'MicroMessenger',
    'Mozilla/5.*Android [1-4]\\..*AppleWebKit',
    'OPR[ /][1-5]\\d\\.',
    'Opera Coast',
    'Opera Mini',
    'Qt/',
    'QuantBrowser',
    'SamsungBrowser.[1-7]\\.',
    'UCBrowser',
    'Version/(\\d|10|11)\\.[\\d.]* Safari',
    'Vivaldi',
    'WorxWeb',
    'Yandex',
    'bit\\.ly',
    'hellotalk',
    'musical_ly',
    'wkhtmltopdf',
];
//# sourceMappingURL=ignoredUserAgents.js.map